import React from 'react';
import Event from '../../models/Event';

export class DeetLabel extends React.Component {

  handleClick = ($event) => {
    $event.preventDefault();
    const { event, handleGoClick } = this.props;
    handleGoClick(event);
  };

  render () {
    const { event, isDesktop } = this.props;
    if (!event) {
      return null;
    }

    return (
      // d-flex and flex classes don't work for whatever god forsaken reason.
      <div className="row no-gutters" style={ {
          display: 'flex',
          flexDirection: isDesktop ? 'row' : 'column'
        } }>

        <h2 className="h3 card-title clickable my-auto mr-2" onClick={ this.handleClick }>
          { Event.getName(event) }
        </h2>

        <div className="flex-fill" />

        <button className={`btn btn-sm btn-light ${isDesktop ? 'm-auto ' : 'mx-auto my-3'}`}
          style={{ minWidth: !!event.sample ? '12rem' : '9.5rem'}}
          data-toggle="tooltip" data-placement="top" title="Participate in POPin"
          onClick={ this.handleClick }
          type="button">
          { !!event.sample ? 'Launch your own' : 'Participate' }
          <i className="material-icons ml-2">chat_bubble_outline</i>
        </button>
      </div>
    );
  }
}
